module.exports = __webpack_public_path__ + "static/media/man.b19a55a2.svg";